import React, { useEffect, useState } from 'react';
import Chip from '@mui/material/Chip';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AddIcon from '@mui/icons-material/Add';
import fetchItemsNextToken from '../../../graphql/fetchItemsNextToken';
import * as queries from '../../../graphql/queries';
import { useDispatch, useSelector } from 'react-redux';

function SubInterest(props) {
  const dispatch = useDispatch();
  const profileReducer = useSelector((state) => state.profileReducer);

    const [interestArr, setInterestArr] = useState([]);

    useEffect(() => {
      const initialFun = async() => {
        if(props.interestID)
        {
            let cardItemDataQuery=await fetchItemsNextToken({query:queries.listSubinterests,variables:{filter: {interestSubinterestsId: {eq: props.interestID}},limit:500}})
            let getCardItemData=cardItemDataQuery.filter(item => item._deleted !== true).sort((a, b) => a.createdAt.localeCompare(b.createdAt));
            if(getCardItemData.length>0)
            {
                const checkboxesData = getCardItemData.map((item) => ({
                    ...item,
                    checked: false,
                }));

                let updatedArray = [];
                if(profileReducer?.userSubInterests?.length>0)
                {
                    console.log('Subinterests', checkboxesData);
                    console.log('User Subinterests', profileReducer?.userSubInterests);

                    updatedArray = checkboxesData.map((item) => {
                        const matchingItem = profileReducer?.userSubInterests.find((otherItem) => otherItem.subinterestID === item.id);
                        if (matchingItem) {
                          return { ...item, checked: true };
                        }
                        return item;
                      }); 
                    console.log('User Subinterests update', updatedArray);
                    if(props?.edit!==false)
                    {
                      const checkedData=updatedArray.filter(item=>item.checked===true)
                      props.onChangeTags(checkedData)
                    }
                    else
                    {
                      updatedArray=updatedArray.filter(item=>item.checked===true)
                    }
                   
                }
                else
                {
                  updatedArray=checkboxesData
                }

                setInterestArr(updatedArray)
            }
        }
      }
    
      initialFun()
    }, [props.interestID,profileReducer?.userSubInterests])
    

    const handleClick = (id) => {
        const updatedCheckboxes = interestArr.map((checkbox) => {
            if (checkbox.id === id) {
                return { ...checkbox, checked: !checkbox.checked };
            }
            return checkbox;
        });
        setInterestArr(updatedCheckboxes);
        const checkedData=updatedCheckboxes.filter(item=>item.checked===true)
        props.onChangeTags(checkedData)
    };

    
  return (
    <>
      {interestArr.length>0 &&
      <>
      {interestArr.map((item, index) =>
        <>
        {props?.edit!==false ?
          <Chip className='chips'
              label={item.name}
              onClick={()=>handleClick(item.id)}
              onDelete={()=>handleClick(item.id)}
              deleteIcon={ item.checked===false ? <AddIcon /> : <CheckCircleIcon className='icon' />}
          />
          :
          <>
          
          <Chip className='chips'
              label={item.name}
              onDelete={()=>console.log(item.id)}
              deleteIcon={ <CheckCircleIcon className='icon' />}
          />
          
          </>
        }
        </>
      )}
      </>
      }
    </>
  )
}

export default SubInterest